import { useMutation } from 'react-query';
import { useAuditActions } from 'react-scale/components/ExpertManagement/stores/audit.store';
import apiFetch, { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';

export const useFetchAttemptAudits = () => {
  const setSubtasks = useAuditActions().setSubtasks;
  return useMutation<any, Error, { attemptIds: string[] }>(
    'useFetchAttemptAudits',
    async ({ attemptIds }) => {
      try {
        setSubtasks(
          await Promise.all(
            attemptIds.map(attemptId =>
              apiFetch(null, `corp-api/attemptAudit/lookup/${attemptId}`, {
                method: 'GET',
              }),
            ),
          ),
        );
      } catch (e) {
        defaultApiFetchErrorHandler(e, { handleHttp: true });
      }
    },
  );
};
